/**
 * Normaliza una fila de suministro para las tablas de luz y gas.
 *
 * El origen legacy deja muchos contratos sin CUPS ni dirección —de los 10.809
 * puntos de gas migrados, 6.255 no tienen CUPS en la plataforma actual—, así que
 * la fila se queda sin nada que la identifique. Se muestra el dato del contrato
 * y, cuando falta, el de la finca, que es el criterio ya acordado para CIF e
 * IBAN. La finca se muestra siempre: es lo único que distingue una fila sin CUPS.
 */
import { estateHolderName } from './estateHolder.js'

const value = (...candidates) => {
  for (const candidate of candidates) {
    if (candidate !== null && candidate !== undefined && String(candidate).trim() !== '') {
      return candidate
    }
  }
  return '-'
}

export const normalizeSupplyRow = (supply, propertyType = '') => ({
  ...supply,
  cups: value(supply.cups),
  address: value(supply.address, supply.property?.address),
  property_name: value(supply.property?.name),
  rate: value(supply.rate),
  company: value(supply.company),
  // Resumen del historial de suministros (ADS-0125): el CP puede venir del
  // contrato; población y provincia viven en la finca.
  postal_code: value(supply.postal_code, supply.property?.postal_code),
  municipality: value(supply.municipality, supply.property?.municipality),
  province: value(supply.province, supply.property?.province),
  // Titular del suministro: el de la finca, con la misma regla que el listado
  // de Inmuebles (ADS-0169); el documento puede venir del contrato o de la finca.
  holder_name: estateHolderName(supply.property, supply.property?.type || propertyType),
  holder_document: value(supply.cif, supply.property?.cif),
  // Cuenta principal de la finca, para saber de qué ficha es cada CUPS (ADS-0186).
  account: value(supply.property?.propietario?.name),
})

export const normalizeSupplyRows = (supplies, propertyType = '') =>
  Array.isArray(supplies) ? supplies.map((supply) => normalizeSupplyRow(supply, propertyType)) : []
